import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import OpenQuoteRepository from "../../../repository/OpenQuoteRepository";
import { __remove, __set } from "../../axios_indicator";

// Thunk slice name should be differnt
export const addQuoteInBulk = createAsyncThunk('open_quote_addQuoteInBulk', async (params) => { // Might benotin use ..need to remove
    return await new OpenQuoteRepository().addQuoteInBulk(params)
});

export const addMultipleQuote = createAsyncThunk('multiple_quote', async (params) => {
    __set('QUOTE_API_CALL');
    return await new OpenQuoteRepository().addMultipleQuote(params);
});

export const getSubmittedQuoteList = createAsyncThunk('open_quote_submitted_quote', async (params) => {
    __set('QUOTE_API_CALL');
    return await new OpenQuoteRepository().getSubmittedQuoteList(params)
});

export const searchQuote = createAsyncThunk('open_quote_search_quote', async (params) => {
    __set('QUOTE_API_CALL');
    return await new OpenQuoteRepository().searchQuote(params)
});

export const getOpenQuoteList = createAsyncThunk('get_open_quote_list', async (params) => {
    __set('QUOTE_API_CALL');
    return await new OpenQuoteRepository().getOpenQuoteListNew(params)
});
export const getQuoteReasonList = createAsyncThunk('get_quote_reason_list', async () => { // 11360
    __set('QUOTE_REASON_API_CALL');
    return await new OpenQuoteRepository().getQuoteReasonList()
});

const initialState = {
    addOpenQuote: {
        data: [],
    },
    openQuoteEditBeforeToSendServer: {
        data: []
    },
    openQuoteList: {},
    openQuoteListTotal: 0,

    quoteHeaderDetail: {},
    lineItems: {},
    submittedQuoteList: {},
    searchQuoteList: {},
    isSuccessAction: false,
    quoteReasonList: []
};

const slice = createSlice({
    name: "OpenQuote",
    initialState: initialState,
    reducers: {
        setAddOpenQuote: {
            reducer: (state, action) => {
                state.addOpenQuote.data = action.payload.data;
            },
        },
        setOpenQuoteEditBeforeToSendServer: {
            reducer: (state, action) => {
                state.openQuoteEditBeforeToSendServer.data = action.payload.data;
            },
        },
        setOpenQuoteList: {
            reducer: (state, action) => {
                state.openQuoteList = action.payload;
            },
        },
        SetClearAllQuote: {
            reducer: (state) => {
                state = initialState;
                return state;
            },
        },
        setIsSuccessAction: {
            reducer: (state, action) => {
                state.isSuccessAction = action.payload;
            },
        }
    },
    extraReducers: {
        [addMultipleQuote.fulfilled]: (state, { payload }) => {
            __remove('QUOTE_API_CALL');
        },
        [addQuoteInBulk.fulfilled]: (state, { payload }) => {
            __remove('QUOTE_API_CALL');
        },
        [getSubmittedQuoteList.fulfilled]: (state, { payload }) => {
            state.submittedQuoteList = payload;
            __remove('QUOTE_API_CALL');
            return state;
        },
        [getSubmittedQuoteList.rejected]: (state, { payload }) => {
            __remove('QUOTE_API_CALL');
        },
        [searchQuote.fulfilled]: (state, { payload }) => {
            state.searchQuoteList = payload?.data?.submittedQuoteSearchList;
            __remove('QUOTE_API_CALL');
            return state;
        },
        [searchQuote.rejected]: (state, { payload }) => {
            __remove('QUOTE_API_CALL');
        },
        [getOpenQuoteList.fulfilled]: (state, { payload }) => {
            state.openQuoteList = payload?.data?.openQuoteList;
            __remove('QUOTE_API_CALL');
            return state;
        },
        [getOpenQuoteList.rejected]: (state, { payload }) => {
            __remove('QUOTE_API_CALL');
        },
        [getQuoteReasonList.fulfilled]: (state, { payload }) => {
            state.quoteReasonList = payload;
            __remove('QUOTE_REASON_API_CALL');
            return state;
        },
        [getQuoteReasonList.rejected]: (state, { payload }) => {
            __remove('QUOTE_REASON_API_CALL');
        },
    },
});

export let {
    setAddOpenQuote, setOpenQuoteEditBeforeToSendServer, setOpenQuoteList, SetClearAllQuote, setIsSuccessAction,
} = slice.actions;

export default slice.reducer;
